import { GetCurrencySymbol } from '../../../../utils/Currency';
import { GetFloatNumber } from '../../../../utils/NumberFormatter';
import { GetDate, GetMonthYear } from '../../../../utils/Show';
import { TextCapitalize } from '../../../../utils/TextFormatter';
import cn from '../../../../utils/cn';

function Container({ children, cardTitle, className }) {
    return (
        <div
            className={cn(
                'relative max-h-[100px] w-full md:max-w-[320px] p-5 !pb-2.5 bg-[rgba(0,145,110,0.5)] rounded-10 border border-[rgba(255,255,255,0.5)]',
                className
            )}
        >
            {children}

            {cardTitle ? (
                <span className="flex items-center justify-center min-h-7 bg-white text-primary text-base font-normal absolute -top-4 left-4 px-2.5 rounded-[7px] box-border">
                    {cardTitle}
                </span>
            ) : null}
        </div>
    );
}

function InfoRow({ title, value }) {
    return (
        <div className="flex gap-x-2 text-base text-white">
            <div className="whitespace-nowrap">
                <span>{title}:</span>
            </div>
            <div className="whitespace-nowrap">
                <span>{value || '------'}</span>
            </div>
        </div>
    );
}

// function CustomerInfo({ data: { customerInfo } }) {
//     return (
//         <Container cardTitle="Customer Info">
//             <InfoRow title="Name" value={customerInfo?.fullName} />
//             <InfoRow title="Email" value={customerInfo?.primaryEmail} />
//             <InfoRow title="Phone" value={customerInfo?.primaryPhone} />
//         </Container>
//     );
// }

function VersionInfo({ data }) {
    return (
        <Container cardTitle="Version Info">
            <InfoRow title="Current Version" value={data?.currentVersion} />
            <InfoRow title="Last Update" value={GetDate(data?.timeClientUpdate)} />
            <InfoRow
                title="First Inst."
                value={`${GetMonthYear(data?.timeFirstInstallation) || '----'}(${data?.installedVersion || '----'})`}
            />
        </Container>
    );
}

function SubscriptionInfo({ data }) {
    return (
        <Container cardTitle="Subscription Info">
            <InfoRow title="Start Date" value={GetDate(data?.timeSubscriptionStart)} />
            <InfoRow
                title="Expired on"
                value={
                    data.limitBy === 'lifetime'
                        ? 'Unlimited Validity'
                        : GetDate(data?.timeSubscriptionEnd)
                }
            />
        </Container>
    );
}

function ContractInfo({ data }) {
    const duration =
        data?.limitBy === 'lifetime'
            ? `${data?.limitByValue} Lifetime`
            : `${data?.limitByValue} ${data?.packageModel}`;

    return (
        <Container cardTitle="Contract Info">
            <InfoRow title="Model" value={TextCapitalize(data?.packageUnitName)} />
            <InfoRow title="Duration" value={duration} />
            <InfoRow
                title="Price"
                value={`${GetCurrencySymbol(data?.contractCurrency)}${GetFloatNumber(data?.contractPrice)}`}
            />
        </Container>
    );
}

function SubscriptionInfoCard({ data }) {
    return (
        <div className="flex flex-wrap lg:flex-nowrap gap-y-6 gap-x-2.5 relative z-10">
            <VersionInfo data={data} />
            <SubscriptionInfo data={data} />
            <ContractInfo data={data} />
        </div>
    );
}

export default SubscriptionInfoCard;
